import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SignalSection } from '../components/SignalSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-233">
      <HeroSection data-id="element-234" />
      <SignalSection data-id="element-235" />
      <DifferenceSection data-id="element-236" />

<PainSection data-id="element-237" />
<BenefitsSection data-id="element-238" />

<ProtocolSection data-id="element-239" />

<ForWhoSection data-id="element-240" />

<TestimonialsSection data-id="element-241" />

      <BibliotecaSection data-id="element-242" />

      <OfferSection data-id="element-243" />
      <AboutSection data-id="element-244" />
      <FAQSection data-id="element-245" />
      <FinalCTASection data-id="element-246" />
    </main>;
}